/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from "react"
import { httpGet } from "../services/Http.service"
import { AxiosResponse } from "axios"
import { apiUrl } from "../configs/config.constants"
import { Product, ProductCategory } from "../types/product.type"
import { DataContext, ProjectContext } from "../App"

export function useGetProducts() {
  const { project } = useContext(ProjectContext)
  const { products, setProducts, productCategories, setProductCategories } = useContext(DataContext)

  useEffect(() => {
    if (project?.projectId && project?.roleAccess?.ecommerce) {
      getProducts()
    }
  }, [project?.projectId])

  function getProducts() {
    if (products.length > 0) return

    httpGet(apiUrl.product.list, {
      limit: 100,
      skip: 0,
    })
      .then((response: AxiosResponse<{ data: Product[] }>) => {
        const products = response.data.data
        const categories = products
          .map((product) => product.category)
          .filter((category): category is ProductCategory => category !== undefined)
          .filter((category, index, self) =>
            index === self.findIndex((c) => c.productCategoryId === category.productCategoryId)
          )
        setProductCategories(categories)
        setProducts(products)
      })
      .catch((error: any) => {
        console.error(error)
      })
  }

  return {
    products,
    productCategories,
  }
}